import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import Content from './Content';
import { i8n } from './i8n';

i8n.setLang(i8n.getUserLang());

const LANDING_ONLY = true;

class App extends Component {
	constructor(props){
		super(props);
		this.state = {last_lang: null};
	}
	componentDidMount(){
		setInterval(() => {
			this.setState({});
		}, 100);
	}
	shouldComponentUpdate(){
		return this.state.last_lang != i8n.current_lang;
	}
	render() {
		return (
			<div className="App">
				<Header isLandingMode={LANDING_ONLY} />
				{!LANDING_ONLY ? <Content /> : null}
				{!LANDING_ONLY ? <Footer /> : null}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js